
 

 

 

 
class ResetPasswordTokenRequest 
{
    
        TokenKey: string;
    
        ResourceUID: string;
    
}
 
export default ResetPasswordTokenRequest;
 




